// ===== CENTRALIZED API CONFIGURATION =====
// Single source of truth for all API endpoints
// Just change REACT_APP_API_URL in your .env files

const API_CONFIG = {
  // Single environment variable controls everything
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  
  // All endpoints derived from BASE_URL
  ENDPOINTS: {
    // Auth
    GOOGLE_CALLBACK: '/auth/google/callback',
    GOOGLE_AUTH: '/auth/google-auth',
    AUTH_ME: '/auth/me',
    
    // Analytics
    ANALYTICS_DASHBOARD: '/analytics/dashboard',
    
    // Admin
    ADMIN_USERS: '/admin/users',
    ADMIN_USER_STATUS: (userId: number) => `/admin/users/${userId}/status`,
    
    // Health
    HEALTH: '/health',
  }
};

// Helper function to build full URLs
export const buildApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Export the config for direct access
export default API_CONFIG; 